export const EXPAND_FEED_ITEM_COMMENTS = 'EXPAND_FEED_ITEM_COMMENTS'
export interface ExpandFeedItemCommentAction {
    type: string
    docId: string
}
export const expandFeedItemComments = (docId: string): ExpandFeedItemCommentAction => ({
    type: EXPAND_FEED_ITEM_COMMENTS,
    docId
})
